import { createFileRoute } from "@tanstack/react-router";
import { NewStudentGroupButton } from "~/components/CreateButtons";
import Link from "~/components/Link";
import { trpc } from "~/utils/trpc.client";

/** Student groups list (was (new)/[teamId]/student-groups/page.tsx). */
export const Route = createFileRoute("/_authed/$teamId/student-groups/")({
  component: StudentGroupsPage,
});

function StudentGroupsPage() {
  const { teamId } = Route.useParams();

  const me = trpc.auth.me.useQuery();
  const personId = me.data?.id;

  const studentGroupsQuery = trpc.students.getStudentGroupsForPerson.useQuery(
    { teamId, personId: personId ?? "" },
    { enabled: !!personId },
  );

  const studentGroups = studentGroupsQuery.data ?? [];

  return (
    <div className="relative m-auto flex h-full w-full max-w-[800px] flex-col gap-4 p-4">
      <div className="flex items-center justify-between">
        <h1 className="text-2xl font-bold">Student Groups</h1>

        <NewStudentGroupButton
          teamId={teamId}
          className="btn btn-primary btn-sm"
        >
          New Student Group
        </NewStudentGroupButton>
      </div>
      <div className="flex flex-col gap-4">
        {studentGroups.map((sg) => (
          <Link
            key={sg.id}
            className="card bg-base-100  shadow"
            href={`/${teamId}/student-groups/${sg.id}`}
          >
            <div className="card-body p-6">
              <span className="">{sg.name}</span>
              <span className="text-xs text-gray-600">{sg.description}</span>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
